let instance = null;

class DomTranslator {
  constructor() {

    if (!instance) {
      this.processing = false;
      this.jQuery = $;
      this.mapper = {};
      this.oTranslation = null;

      this.config = {
        container: '#wrap',
        consider: ['label'],
        placeholderNotation: '@@',
        language: 'en-US'
      }

      this.oContainer = {};
      this.translated = {};
      this.addingTranslationTagsList = [];

      instance = this;
    }

    return instance;
  }

  initTranslation() {

    return new Promise((resolve, reject) => {

      if (this.oTranslation) {
        return resolve();
      }

      Translations.instance.init()
        .then(()=> {
          this.oTranslation = Translations.instance.getData();
          resolve();
        })
    })
  }

  getMapper() {
    return new Promise((resolve, reject) => {

      if (this.jQuery.isEmptyObject(this.oTranslation)) {
        return resolve();
      }

      this.mapper = Object.assign({}, ...Object.entries(this.oTranslation['de-DE']).map(([a,b]) => ({ [b]: a })));

      resolve();

    });
  }

  setContainer(container) {
    this.config.container = container;
    return this;
  }

  setConsider(consider) {
    this.config.consider = consider;
    return this;
  }

  setLanguage(language) {
    this.config.language = language;
    return this;
  }

  getTranslationKey(oElement, attributeName) {
    let mapperKey = "";

    if (attributeName === 'text') {
      mapperKey = this.cleanString(oElement.text()) || false;
    } else {
      mapperKey = oElement.attr(attributeName) || false;
    }

    return this.mapper[mapperKey] || false;
  }

  getTranslation(oElement, attributeName, translationKey) {
    if (!translationKey) {
      translationKey = this.getTranslationKey(oElement, attributeName);
    }
    if (translationKey) {
      return this.oTranslation[this.config.language][translationKey];
    } else {
      return false;
    }
  }

  cleanString(str) {
    if (typeof str !== 'string') {
      return;
    }
    return str.replace('&nbsp;', '').trim();

  }

  translateAttribute(oElement, attributeName) {

    if (!oElement.attr(attributeName)) {
      return;
    }

    let translation = this.getTranslation(oElement, attributeName);

    if (translation) {
      oElement.attr(attributeName, translation) || oElement.attr(attributeName);
    }
  }

  addTranslationTagsToElements(selector, attributeName) {

    const self = this;
    const oElements = this.oContainer.find(selector);

    oElements.each((index, element) => {

      let oElement = this.jQuery(element);
      let oNotationValue = oElement.attr(attributeName).match(/{([^}]*)}/);
      oElement.attr('dt-translate', oNotationValue ? oNotationValue[1] : self.getTranslationKey(oElement, attributeName));
      oElement.attr('dt-translate-attribute-source', attributeName);

    });
  }

  processTagsAndNotations() {

    // search for translate tags and replace contents
    let oElement = {};
    let translation;

    if (!this.oTranslation) {
      return;
    }

    if (!this.oContainer) {
      this.oContainer = this.jQuery(this.oContainer);
    }

    // todo not(['data-translation-key']
    this.oContainer.find('[dt-translate]').each((index, element) => {
      oElement = this.jQuery(element);

      // from text()
      if (oElement.attr('dt-translate').trim() === '') {
        // has no attribute value, so translate inner text

        let translationKey = oElement.attr('data-translation-key');
        if (translationKey !== undefined) {
          // translation key exist, use this
          translation = this.oTranslation[this.config.language][translationKey];
        } else {
          oElement.attr('data-translation-key', this.cleanString(oElement.text()));
          translation = this.oTranslation[this.config.language][oElement.text().trim()];
        }

        if (self.jQuery.isArray(translation)) {
          oElement.html(translation.join(""))
        } else {
          oElement.text(translation);
        }

      } else {
        // has attribute value, so we use this

        translation = this.oTranslation[this.config.language][oElement.attr('dt-translate')];

        if (self.jQuery.isArray(translation)) {
          if (oElement.attr('dt-translate-attribute-source')) {
            oElement.attr(oElement.attr('dt-translate-attribute-source'), translation.join(''));
          } else {
            oElement.html(translation.join(''));
          }

        } else {
          if (oElement.attr('dt-translate-attribute-source')) {
            oElement.attr(oElement.attr('dt-translate-attribute-source'), this.cleanString(translation));
          } else {
            oElement.text(this.cleanString(translation));
          }
        }
      }
    });
  }

  manipulateElement(element) {

    const oElement = $(element);

    if (oElement.attr('dt-translate') !== undefined) {
      return;
    }

    let translation;
    const elementType = oElement.get(0).tagName;

    switch (elementType) {

      case 'INPUT': {
        this.translateAttribute(oElement, 'placeholder');
        this.translateAttribute(oElement, 'value');
      }
      case 'TEXTAREA': {
        this.translateAttribute(oElement, 'placeholder');
      }
      case 'A': {
        this.translateAttribute(oElement, 'title');
      }
      case 'IMG': {
        this.translateAttribute(oElement, 'alt');
        this.translateAttribute(oElement, 'title');
      }
      case 'BUTTON': {
        this.translateAttribute(oElement, 'button');
      }
      default: {


        if (oElement.attr('data-translation-key') === undefined) {

          translation = this.getTranslation(oElement, 'text');
          let transKey = this.getTranslationKey(oElement, 'text');

          if (transKey) {
            oElement.attr('data-translation-key', transKey);
          }

        } else {
          translation = this.getTranslation(oElement, 'text', oElement.attr('data-translation-key'));
        }

        if (translation) {
          // if radio or checkbox with space
          translation = oElement.contents().has('input') ? ' ' + translation : translation;

          if (oElement.find('button').length === 0 && oElement.find('a').length === 0 && oElement.find('span').length === 0) {
            oElement
              .contents()
              .last()
              .replaceWith(translation);
          }

        }

      }
    }

  }

  reserveForAddingTranslationTags(aElements) {
    this.addingTranslationTagsList = aElements;
    return this;
  }

  processTranslation(render) {
    let elements = [];
    const consider = this.config.consider;

    this.oContainer = typeof this.config.container === 'object' ? this.config.container : this.jQuery(this.config.container);

    if (!render) {
      this.oContainer = this.oContainer.clone();
    }

    // Alle in "consider" (setConsider) angegebenen Elemente werden iteriert und entsprechende Texte durch die Übersetzungen ersetzt.
    consider.forEach((selector) => {
      elements = this.oContainer.find(selector);
      if (elements.length > 0) {
        // get value and translate it
        elements.each((index, element) => {
          if (self.jQuery(element).closest('.dt-do-not-translate').length === 0) {
            this.manipulateElement(element);
          }
        });
      }
    });

    if (this.addingTranslationTagsList.length > 0) {
      this.addingTranslationTagsList.forEach((item) => {
        this.addTranslationTagsToElements(item.selector, item.attributeName);
      });
    }
    this.processTagsAndNotations();
    return this.oContainer
  }

  init() {
    return new Promise((resolve, reject) => this.initTranslation().then( () => {
      this.bindDocument();
      resolve();
    }));
  }

  bindDocument()
  {
    this.jQuery(document).bind('ready', this.render());
    this.jQuery(document).ajaxComplete(() => this.render());
  }

  render(container) {

    const standardContainer = this.config.container;

    return new Promise((resolve, reject) => {

      this.setContainer(container || this.config.container);

      this.getMapper()
        .then(this.processTranslation(true))
        .then(() => {
          this.setContainer(standardContainer);
          resolve();
        });

    });
  }

  get(locoKey, locale) {
    const currentLocale = (locale || this.config.language).replace('_', '-');
    return this.oTranslation[currentLocale][locoKey] || locoKey;
  }

}